import React from 'react';
import Routers from './Route';
import FilterProvider from './_helper/Ecommerce/Filter/FilterProvider';
import WishListProvider from './_helper/Ecommerce/Wishlist/WishlistProvider';
import AnimationThemeProvider from './_helper/AnimationTheme/AnimationThemeProvider';
import CustomizerProvider from './_helper/Customizer/CustomizerProvider';

const App = () => (
  <div className='App'>
    <CustomizerProvider>
      <WishListProvider>
        <FilterProvider>
          <AnimationThemeProvider>
            <Routers />
          </AnimationThemeProvider>
        </FilterProvider>
      </WishListProvider>
    </CustomizerProvider>
  </div>
);

export default App;